import styled from "styled-components";

export const LineupTableStyled = styled.div.attrs(() => ({}))`
  .react-grid-HeaderCell {
    font-size: 14px !important;
  }
`;
